export default {
  'pages.rounds.reports': 'რეპორტები',
  'pages.rounds.operators': 'ოპერატორები',
  'pages.rounds.games': 'თამაშები',
  'pages.rounds.userId': 'მოთამაშეს Operator ID',
  'pages.rounds.transactionGroupId': 'ტრანზაქციის ჯგუფის ID',
  'pages.rounds.rgsUserId': 'RGS მოთამაშის ID',
  'pages.rounds.partnerName': 'პარტნიორის სახელი',
  'pages.rounds.endDate': 'დასრულების თარიღი',
  'pages.rounds.startDate': 'დაწყების თარიღი',
  'pages.rounds.search': 'ძიება',
  'pages.rounds.errorText': 'შეცდომის ტექსტი',
  'pages.rounds.errorCode': 'შეცდომის კოდი',
  'pages.rounds.currency': 'ვალუტა',
  'pages.rounds.status': 'სტატუსი',
  'pages.rounds.betAmount': 'Bet თანხა',
  'pages.rounds.winAmount': 'მოგების თანხა',
  'pages.rounds.multiplier': 'Multiplier',
  'pages.rounds.crashPoint': 'Crash წერტილი',
  'pages.rounds.betId': 'Bet ID',
  'pages.rounds.gameName': 'თამაშის სახელი',
  'pages.rounds.username': 'მომხმარებელი',
  'pages.players.reports': 'რეპორტები',
  'pages.players.betNumber': 'Bet რაოდენობა',
  'pages.players.name': 'მოთამაშე',
  'pages.players.endDate': 'დასრულების თარიღი',
  'pages.players.startDate': 'დაწყების თარიღი',
  'pages.players.search': 'ძიება',
  'pages.players.games': 'თამაშები',
  'pages.players.id': 'მოთამაშის ID',
  'pages.players.operators': 'ოპერატორები',
  'pages.players.partners': 'პარტნიორები',
  'pages.players.partner': 'პარტნიორი',
  'pages.players.operator': 'ოპერატორი',
  'pages.players.game': 'თამაში',
  'pages.players.bet': 'Bet',
  'pages.players.win': 'მოგება',
  'pages.players.ggr': 'GGR',
  'pages.players.users': 'მომხმარებლები',
  'pages.players.spins': 'Spin',
  'pages.stats.reports': 'რეპორტები',
  'pages.stats.betNumber': 'Bet რაოდენობა',
  'pages.stats.endDate': 'დასრულების თარიღი',
  'pages.stats.startDate': 'დაწყების თარიღი',
  'pages.stats.search': 'ძიება',
  'pages.stats.games': 'თამაშები',
  'pages.stats.operators': 'ოპერატორები',
  'pages.stats.partners': 'პარტნიორები',
  'pages.stats.partner': 'პარტნიორი',
  'pages.stats.operator': 'ოპერატორი',
  'pages.stats.game': 'თამაში',
  'pages.stats.bet': 'Bet',
  'pages.stats.win': 'მოგება',
  'pages.stats.ggr': 'GGR',
  'pages.stats.users': 'მომხმარებლები',
  'pages.stats.spins': 'Spin',
  'charts.bets.wins.title': 'ფსონი მოგება',
  'charts.players.title': 'მოთამაშეები',
  'charts.ggr.title': 'GGR',
  'pages.dashboard.betWins': 'ფსონი მოგება',
  'pages.dashboard.players': 'მოთამაშეები',
  'pages.dashboard.ggr': 'GGR',
  'pages.dashboard.topPlayers': 'ტოპ მოთამაშეები',
  'pages.dashboard.spins': 'სპინები',
  'pages.dashboard.player': 'მოთამაშე',
  'pages.dashboard.win': 'მოგება',
  'pages.dashboard.bet': 'ფსონის გადატანა',
  'pages.dashboard.game': 'თამაში',
  'pages.dashboard.operator': 'ოპერატორი',
  'pages.dashboard.partner': 'პარტნიორი',
  'pages.dashboard.numOfUniqueUsers': 'უნიკალური მომხმარებელის რაოდენობა',
  'pages.dashboard.numberSpins': 'სპინების რაოდენობა',
  'pages.dashboard.search': 'ძიება',
  'pages.dashboard.games': 'თამაშები',
  'pages.dashboard.operators': 'ოპერატორები',
  'pages.dashboard.partners': 'პარტნიორები',
  'pages.dashboard.live': 'მიმდინარე',
  'pages.dashboard.detailedLivePlayers': 'აქტიური მოთამაშეები დეტალურად',
  'pages.dashboard.groupBy': 'დაჯგუფება',
  'pages.dashboard.liveCount': 'აქტიური',
  'pages.dashboard.livePlayers': 'აქტიიური მოთამაშეები',
  'pages.dashboard.partnerOperator': 'პარტნიორი+ოპერატორი',
  'pages.dashboard.fetchDataError': 'მონაცემების მიღება ვერ მოხერხდა',
  'pages.layouts.userLayout.title': 'RGS',
  'pages.login.accountLogin.tab': 'ანგარიშით შესვლა',
  'pages.login.accountLogin.errorMessage': 'არასწორი მომხმარებელი/პაროლი (admin/ant.design)',
  'pages.login.failure': 'შესვლა ვერ მოხერხდა, გთხოვთ სცადოთ თავიდან!',
  'pages.login.success': 'შესვლა წარმატებით შესრულდა!',
  'pages.login.username.placeholder': 'მომხმარებელი',
  'pages.login.username.required': 'გთხოვთ შეიყვანოთ მომხმარებელი!',
  'pages.login.password.placeholder': 'პაროლი',
  'pages.login.password.required': 'გთხოვთ შეიყვანოთ პაროლი!',
  'pages.login.phoneLogin.tab': 'ტელეფონით შესვლა',
  'pages.login.phoneLogin.errorMessage': 'ვერიფიკაციის კოდი არასწორია',
  'pages.login.phoneNumber.placeholder': 'ტელეფონის ნომერი',
  'pages.login.phoneNumber.required': 'გთხოვთ შეიყვანოთ თქვენი ტელეფონის ნომერი!',
  'pages.login.phoneNumber.invalid': 'ტელეფონის ნომერი არასწორია!',
  'pages.login.captcha.placeholder': 'ვერიფიკაციის კოდი',
  'pages.login.captcha.required': 'გთხოვთ შეიყვანოთ ვერიფიკაციის კოდი!',
  'pages.login.phoneLogin.getVerificationCode': 'კოდის მიღება',
  'pages.getCaptchaSecondText': 'წმ.(ებ)',
  'pages.login.rememberMe': 'დამახსოვრება',
  'pages.login.forgotPassword': 'დაგავიწყდათ პაროლი?',
  'pages.login.submit': 'შესვლა',
  'pages.login.loginWith': 'შესვლა მეშვეობით:',
  'pages.login.registerAccount': 'ანგარიშის რეგისტრაცია',
  'pages.welcome.link': 'მოგესალმებით',
  'pages.welcome.alertMessage': 'უფრო სწრაფი და ძლიერი კომპონენტები უკვე ხელმისაწვდომია.',
  'pages.404.subTitle': 'ბოდიშით, თქვენ მიერ მონახულებული გვერდი არ არსებობს.',
  'pages.404.buttonText': 'მთავარ გვერდზე დაბრუნება',
  'pages.admin.subpages.title': 'ამ გვერდის ნახვა მხოლოდ ადმინისტრატორს შეუძლია',
  'pages.admin.subpages.alertMessage':
    'Umi UI უკვე გამოვიდა, სცადეთ npm run ui რათა დაიწყოთ გამოცდილება.',
  'pages.searchTable.createForm.newRule': 'ახალი წესი',
  'pages.searchTable.updateForm.ruleConfig': 'წესის კონფიგურაცია',
  'pages.searchTable.updateForm.basicConfig': 'ძირითადი ინფორმაცია',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'წესის სახელი',
  'pages.searchTable.updateForm.ruleName.nameRules': 'გთხოვთ შეიყვანოთ წესის სახელი!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'წესის აღწერა',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'გთხოვთ შეიყვანოთ მინიმუმ ხუთი სიმბოლო',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'გთხოვთ შეიყვანოთ წესის აღწერა მინიმუმ ხუთი სიმბოლოთი!',
  'pages.searchTable.updateForm.ruleProps.title': 'პარამეტრების კონფიგურაცია',
  'pages.searchTable.updateForm.object': 'მონიტორინგის ობიექტი',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'წესის შაბლონი',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'წესის ტიპი',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'დაგეგმვის პერიოდის დაყენება',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'დაწყების დრო',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'გთხოვთ აირჩიოთ დაწყების დრო!',
  'pages.searchTable.titleDesc': 'აღწერა',
  'pages.searchTable.ruleName': 'წესის სახელი აუცილებელია',
  'pages.searchTable.titleCallNo': 'სერვისის ზარების რაოდენობა',
  'pages.searchTable.titleStatus': 'სტატუსი',
  'pages.searchTable.nameStatus.default': 'ნაგულისხმები',
  'pages.searchTable.nameStatus.running': 'მიმდინარეობს',
  'pages.searchTable.nameStatus.online': 'ონლაინ',
  'pages.searchTable.nameStatus.abnormal': 'არანორმალური',
  'pages.searchTable.titleUpdatedAt': 'ბოლო დაგეგმვა',
  'pages.searchTable.exception': 'გთხოვთ შეიყვანოთ გამონაკლისის მიზეზი!',
  'pages.searchTable.titleOption': 'ოპცია',
  'pages.searchTable.config': 'კონფიგურაცია',
  'pages.searchTable.subscribeAlert': 'გაფრთხილების გამოწერა',
  'pages.searchTable.title': 'ძიების ფორმა',
  'pages.searchTable.new': 'ახალი',
  'pages.searchTable.chosen': 'არჩეული',
  'pages.searchTable.item': 'ელემენტი',
  'pages.searchTable.totalServiceCalls': 'სერვისის ზარების მთლიანი რაოდენობა',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'ჯგუფური წაშლა',
  'pages.searchTable.batchApproval': 'ჯგუფური დადასტურება',
  'pages.promoCampaign.audienceAndBudgetControl': 'აუდიტორია',
  'pages.promoCampaign.eligibilityFilters': 'შესარჩევი ფილტრები',
  'pages.promoCampaign.minBetAmountForBonusRound': 'მინიმალური ფსონის ოდენობა ბონუს რაუნდისთვის',
  'pages.promoCampaign.minTotalWagerBeforeEvent': 'მინ. სულ ფსონი მოვლენამდე',
  'pages.promoCampaign.lookbackWindow': 'უკან მიმოხილვის ფანჯარა',
  'pages.promoCampaign.lookbackUnit.minutes': 'წუთი',
  'pages.promoCampaign.lookbackUnit.hours': 'საათი',
  'pages.promoCampaign.optional': 'არასავალდებულო',
  'pages.promoCampaign.claimLimitations': 'მოთხოვნის ლიმიტები',
  'pages.promoCampaign.maxClaimsPerEvent': 'მაქს. მოთხოვნა მოთამაშეზე მოვლენაზე',
  'pages.promoCampaign.maxClaimsPerDay': 'მაქს. მოთხოვნა მოთამაშეზე დღეში',
  'pages.promoCampaign.claimTimeLimit': 'მოთხოვნის ვადა დროპის შემდეგ (წუთი)',
  'pages.promoCampaign.minimumCashoutMultiplierForFreeSpins':
    'მინ. გატანის მულტიპლიკატორი უფასო სპინებისთვის',
  'pages.promoCampaign.giftValue': 'საჩუქრის ღირებულება',
  'pages.promoCampaign.giftValues': 'საჩუქრის ღირებულებები',
  'pages.promoCampaign.minCashoutMultiplier': 'მინ. გატანის მულტიპლიკატორი',
  'pages.promoCampaign.editValues': 'რედაქტირება',
  'pages.promoCampaign.editGiftValues': 'საჩუქრის ღირებულებების რედაქტირება',
  'pages.promoCampaign.selectCurrenciesFirst': 'ჯერ აირჩიეთ ვალუტები ზოგად პარამეტრებში',
  'pages.promoCampaign.actions': 'მოქმედებები',
  'pages.promoCampaign.view': 'ნახვა',
  'pages.promoCampaign.delete': 'წაშლა',
  'pages.promoCampaign.deleteSuccess': 'კამპანია წაიშლა',
  'pages.promoCampaign.deleteError': 'კამპანიის წაშლა ვერ მოხერხდა',
  'pages.promoCampaign.deleteConfirmTitle': 'წავშალოთ კამპანია?',
  'pages.promoCampaign.deleteConfirmDescription': 'ამ მოქმედების გაუქმება შეუძლებელია.',
  'pages.promoCampaign.deleteConfirmOk': 'წაშლა',
  'pages.promoCampaign.deleteConfirmCancel': 'გაუქმება',
  'pages.report.preview': 'გადახედვა (პირველი 30 ჩანაწერი)',
  'pages.report.preview.day': 'დღე (UTC)',
  'pages.report.preview.gameName': 'თამაშის სახელი',
  'pages.report.preview.currencyCode': 'ვალუტა',
  'pages.report.preview.partnerName': 'პარტნიორის სახელი',
  'pages.report.preview.operatorName': 'ოპერატორის სახელი',
  'pages.report.preview.bets': 'ფსონები',
  'pages.report.preview.wins': 'მოგებები',
  'pages.report.preview.ggr': 'GGR',
  'pages.report.preview.betsEUR': 'ფსონები (EUR)',
  'pages.report.preview.winsEUR': 'მოგებები (EUR)',
  'pages.report.preview.ggrEUR': 'GGR (EUR)',
  'pages.report.exportError': 'ექსპორტის შეცდომა: ',
  'pages.report.previewError': 'გადახედვის შეცდომა: ',
  'pages.operatorSetup.partnerPlaceholder':
    'აირჩიეთ არსებული პარტნიორი ან ჩაწერეთ ახალი პარტნიორის სახელი',
  'pages.operatorSetup.operatorPlaceholder': 'ჩაწერეთ ახალი ოპერატორის სახელი',
  'pages.operatorSetup.operatorAPIEndpoint': 'ოპერატორის API Endpoint',
  'pages.operatorSetup.operatorConfig': 'კონფიგურაცია',
  'pages.operatorSetup.operatorKeyConfig': 'ოპერატორის გასაღების დამატება',
  'pages.operatorSetup.operatorKeyConfig.leaveEmpty': 'ცარიელი დატოვება',
  'pages.operatorSetup.operatorKeyConfig.reuse': 'არსებული ოპერატორის გასაღების გამოყენება',
  'pages.operatorSetup.operatorKeyConfig.create': 'ახალი გასაღების შექმნა',
  'pages.operatorSetup.operatorKeyConfig.operatorKeyAction': 'მოქმედება',
  'pages.operatorSetup.operatorKeyConfig.keySourceOperator': 'გასაღების წყარო ოპერატორი',
  'pages.operatorSetup.operatorKeyConfig.apiKey': 'API გასაღები',
  'pages.operatorSetup.operatorKeyConfig.secretKey': 'საიდუმლო გასაღები',
  'pages.operatorSetup.instructions.title': 'ოპერატორის ინსტრუქცია',
  'pages.operatorSetup.createButton': 'შექმნა',
  'pages.operatorSetup.createSuccess': 'ოპერატორი წარმატებით შეიქმნა',
  'pages.operatorSetup.createError': 'ოპერატორის შექმნა ვერ მოხერხდა: ',
  'pages.operatorSetup.apiEndpointPlaceholder':
    'აირჩიეთ არსებული API Endpoint ან ჩაწერეთ ახალი API Endpoint',
  'pages.settings.betting.addSettingsButton': 'პარამეტრების დამატება',
  'pages.settings.betting.lookupSettingsButton': 'პარამეტრების ძებნა',
  'pages.settings.betting.upsertButton': 'პარამეტრის დამატება',
  'pages.settings.betting.upsertTooltip':
    'ეს ღილაკი ან დაამატებს ახალ პარამეტრს ან განაახლებს არსებულს',
  'pages.settings.betting.fetchError': 'ფსონების პარამეტრების მიღება ვერ მოხერხდა',
  'pages.settings.betting.convertSuccess':
    'ფსონების პარამეტრები წარმატებით დაკონვერტირდა და დაემატა',
  'pages.settings.betting.convertError':
    'ფსონების პარამეტრების კონვერტაცია და დამატება ვერ მოხერხდა',
  'pages.settings.betting.upsertSuccess': 'ფსონების პარამეტრი წარმატებით განახლდა',
  'pages.settings.betting.upsertError': 'ფსონების პარამეტრის განახლება ვერ მოხერხდა',
  'pages.settings.betting.deleteSuccess': 'ფსონების პარამეტრი წარმატებით წაიშალა',
  'pages.settings.betting.deleteError': 'ფსონების პარამეტრის წაშლა ვერ მოხერხდა',
  'pages.settings.betting.partnerOptional': 'პარტნიორი (არასავალდებულო)',
  'pages.settings.betting.operatorOptional': 'ოპერატორი (არასავალდებულო)',
  'pages.settings.betting.gameOptional': 'თამაში (არასავალდებულო)',
  'pages.settings.betting.partner': 'პარტნიორი',
  'pages.settings.betting.operator': 'ოპერატორი',
  'pages.settings.betting.game': 'თამაში',
  'pages.settings.betting.sourceCurrency': 'წყარო ვალუტა',
  'pages.settings.betting.key': 'გასაღები',
  'pages.settings.betting.value': 'მნიშვნელობა',
  'pages.settings.betting.actions': 'მოქმედებები',
  'pages.settings.betting.delete': 'წაშლა',
  'pages.settings.betting.currency': 'ვალუტა',
  'pages.settings.betting.currencies': 'ვალუტები',
  'pages.settings.betting.currencyPlaceholder': 'აირჩიეთ ვალუტა',
  'pages.settings.betting.filterButton': 'გაფილტვრა',
  'pages.settings.betting.deleteConfirmTitle': 'გსურს ამ ფსონების პარამეტრის წაშლა?',
  'pages.settings.betting.confirmDeleteButton': 'წაშლა',
  'pages.settings.betting.cancelButton': 'გაუქმება',
  'pages.settings.betting.leaveEmptyForGlobal': 'გლობალური პარამეტრისთვის დატოვეთ ცარიელი',
  'pages.settings.betting.bettingSettingsContext': 'ფსონების პარამეტრების კონტექსტი',
  'pages.settings.betting.keyPlaceholder': 'აირჩიეთ პარამეტრის გასაღები',
  'pages.settings.betting.valuePlaceholder': 'მიუთითეთ პარამეტრის მნიშვნელობა',
  'pages.settings.betting.settingKeyValueTitle': 'პარამეტრის გასაღები/მნიშვნელობა',

  'pages.assistant.type.betTransactionId': 'რაუნდის / ფსონის ტრანზაქციის ID',
  'pages.assistant.type.id': 'ტრანზაქციის ID',
  'pages.assistant.type.operatorTransactionId': 'ოპერატორის ტრანზაქციის ID',
  'pages.assistant.identifierPlaceholder': 'იდენტიფიკატორი',
  'pages.assistant.lookUp': 'მოძებნა',
  'pages.assistant.startAssistant': 'ასისტენტის კითხვა',
  'pages.assistant.startAssistantHint':
    'ქვემოთ მოცემულ მტკიცებულებას გაუგზავნის მოდელს დიაგნოსტიკისთვის.',
  'pages.assistant.stop': 'შეჩერება',
  'pages.assistant.newDiagnosis': 'ახალი დიაგნოსტიკა',
  'pages.assistant.rangeRequired':
    'ოპერატორის ტრანზაქციის ID-ით ძიებისას თარიღის დიაპაზონი სავალდებულოა',
  'pages.assistant.rangeTooWide': 'თარიღის დიაპაზონი უნდა იყოს {days} დღე ან ნაკლები',
  'pages.assistant.rangeHint':
    'ოპერატორის ტრანზაქციის ID არ არის ინდექსირებული, ამიტომ ძიების შესაზღუდად საჭიროა თარიღის დიაპაზონი.',
  'pages.assistant.ambiguous': 'ეს იდენტიფიკატორი ემთხვევა რამდენიმე რაუნდს — აირჩიეთ ერთი',
  'pages.assistant.select': 'რაუნდის გახსნა',
  'pages.assistant.you': 'თქვენ',
  'pages.assistant.assistant': 'ასისტენტი',
  'pages.assistant.followUpPlaceholder': 'დასვით დამატებითი კითხვა',
  'pages.assistant.send': 'გაგზავნა',
  'pages.assistant.evidence.transactions': 'ტრანზაქციები ({count})',
  'pages.assistant.evidence.logs': 'პლატფორმის ლოგები ({count})',
  'pages.assistant.evidence.logsSearching': 'პლატფორმის ლოგები (მიმდინარეობს ძიება…)',
  'pages.assistant.evidence.type': 'ტიპი',
  'pages.assistant.evidence.status': 'სტატუსი',
  'pages.assistant.evidence.transactionId': 'ტრანზაქციის ID',
  'pages.assistant.evidence.created': 'შექმნილია',
  'pages.assistant.evidence.processed': 'დამუშავებულია',
  'pages.assistant.evidence.error': 'შეცდომა',
  'pages.assistant.evidence.archived': 'დაარქივებული',
  'pages.assistant.evidence.round': 'რაუნდი (ფსონის ტრანზაქციის ID)',
  'pages.assistant.evidence.operator': 'ოპერატორი',
  'pages.assistant.evidence.game': 'თამაში',
  'pages.assistant.evidence.timezoneNote': 'დრო ნაჩვენებია {timezone}-ის მიხედვით ({offset})',
  'pages.assistant.evidence.expandRow': 'მწკრივის გაშლა',
  'pages.assistant.evidence.collapseRow': 'მწკრივის დახურვა',
  'pages.assistant.evidence.requestPayload': 'მოთხოვნის მონაცემები',
  'pages.assistant.evidence.responsePayload': 'პასუხის მონაცემები',
  'pages.assistant.evidence.windows': 'მოძიებული ინტერვალები',
  'pages.assistant.evidence.matched': 'ნაპოვნი ჩანაწერები',
  'pages.assistant.evidence.truncated': 'შემოკლებულია ზომის ლიმიტის გამო',
  'pages.assistant.evidence.query': 'მოთხოვნა',
  'pages.assistant.evidence.logsUnavailable': 'ლოგები მიუწვდომელია',
  'pages.assistant.evidence.logsPartial': 'ლოგები არასრულია — ზოგიერთი ძიება ვერ შესრულდა',
  'pages.assistant.evidence.logsEmpty': 'შესაბამისი ლოგები ვერ მოიძებნა',
  'pages.assistant.evidence.logFilter': 'ჩანაწერების ფილტრი',
  'pages.assistant.evidence.logShowing': 'ნაჩვენებია {shown} / {total}',
  'pages.assistant.evidence.logFilterEmpty': 'ფილტრს არცერთი ჩანაწერი არ ემთხვევა',
  'pages.assistant.evidence.logsCaveat':
    'ლოგების არარსებობა არ ნიშნავს, რომ არაფერი მომხდარა — ლოგები ინახება შეზღუდული პერიოდით, ამიტომ ძველ რაუნდებს ხშირად არ აქვთ ლოგები.',
  'pages.assistant.evidence.warnings': 'ზოგიერთი მტკიცებულების შეგროვება ვერ მოხერხდა',
  'pages.assistant.evidence.eurAmounts': 'EUR (ფსონი / მოგება)',
  'pages.assistant.evidence.operatorCalls': 'ოპერატორის გამოძახებები ({count})',
  'pages.assistant.evidence.operatorCallsEmpty':
    'ასეთი ჩანაწერები ვერ მოიძებნა. ეს DEBUG ჩანაწერებია და body მხოლოდ მაშინ იწერება, როცა ოპერატორის body-ის ლოგირება ჩართულია.',
  'pages.assistant.evidence.crashPoint': 'Crash წერტილი',
  'pages.assistant.evidence.tripIdValue': 'ტრიპი {tripId}',
  'pages.assistant.evidence.eurBet': 'EUR (ფსონი)',
  'pages.assistant.evidence.eurWin': 'EUR (მოგება)',
  'pages.assistant.evidence.testUser': 'სატესტო მომხმარებელი',
  'pages.assistant.evidence.bettingSettings': 'ფსონის ლიმიტები',
  'pages.assistant.evidence.bettingSettingsValue':
    'მინ. {minBet} · მაქს. {maxBet} · მაქს. მოგება {maxWin}{disabled}',
  'pages.assistant.evidence.currencyDisabled': 'ვალუტა გამორთულია',
  'pages.assistant.evidence.gameEvents': 'თამაშის მოვლენები ({count})',
  'pages.assistant.evidence.tripId': 'Trip ID',
  'pages.assistant.evidence.eventType': 'მოვლენის ტიპი',
  'pages.assistant.evidence.payload': 'მონაცემები',
  'pages.assistant.evidence.retryQueue': 'გამეორების რიგი ({count})',
  'pages.assistant.evidence.retryCount': 'მცდელობების რაოდენობა',
  'pages.assistant.evidence.updated': 'განახლდა',
};
